// v-money
export const Money = {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2,
  masked: false,
}

// v-money
export const Percent = {
  decimal: ',',
  thousands: '.',
  prefix: '',
  suffix: ' %',
  precision: 2,
  masked: false,
}

export const Neutral = {
  decimal: ',',
  thousands: '.',
  prefix: '',
  suffix: '',
  precision: 2,
  masked: false,
}

// v-mask
export const masks = {
  number: '#######################',
  data: '##/##/####',
  dataYearFirst: '####/##/##',
  dataRef: '##/####',
  dataVenc: '##/##',
  cvc: '###',
  card_number: '#### #### #### ####',
  phone: ['(##) ####-####', '(##) #####-####'], // Usar lista com referencia individuais
  phoneShort: '(##) ####-####',
  phoneLong: '(##) #####-####',
  phoneWithCountryCodeBrazil: '+## (##) ####-####',
  phoneWithCountryCodeBrazilExtended: '+## (##) #####-####',
  cpf: '###.###.###-##',
  cnpj: '##.###.###/####-##',
  // cpf_cnpj: ['###.###.###-##', '##.###.###/####-##'], // Usar lista com referencias individuais
  cep: '#####-###',
  codigoBoleto: '#####.##### #####.###### #####.###### # ##############',
  imposto: '########### #  ########### #  ########### #  ########### #',
  year: '####',
  liquidity: 'D+####',
}

export default {
  Money,
  Percent,
  masks,
  Neutral,
}
